export default __webpack_public_path__ + "static/media/esrb-teen.056ff0bc.svg";